import { Component, OnInit, ViewChild, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Settings, AppSettings } from '../app.settings';
import { isPlatformBrowser } from '@angular/common';
import { AppService } from '../app.service';
import { SitesService } from '../admin/1.tv/sites/sites.service';
import { environment } from 'src/environments/environment';
import { Site } from '../admin/1.tv/sites/sites.model';
import { Observable, of } from 'rxjs';
import { StripeResponseService } from '../services/stripe-response.service';
// import { CompanySiteToStoreService } from '../admin/1.tv/company-site-to-store/company-site-to-store.service';
// import { SitesService } from '../admin/1.tv/sites/sites.service';
// import { Observable, of, Subscription } from 'rxjs';
// import { Site } from '../admin/1.tv/sites/sites.model';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit {
  @ViewChild('sidenav') sidenav: any;
  public headerTypes = ['default', 'image', 'carousel', 'video'];
  public headerTypeOption = '';
  public headerFixed = false;
  public showBackToTop = false;

  public settings: Settings;
  // private sub1: Subscription;
  private companyId = '';
  private siteId = '';
  public sites$: Observable<Site[]>;

  constructor(
    // private companySiteToStoreService: CompanySiteToStoreService,
    private sitesService: SitesService,
    public appSettings: AppSettings,
    public router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    public appService: AppService,
    private stripeResponseService: StripeResponseService) {
    this.settings = this.appSettings.settings;

    this.companyId = stripeResponseService.companyId;
    this.siteId = stripeResponseService.siteId;

    console.log(this.companyId );
    console.log(this.siteId );

    this.sitesService.findSiteByCompanyIdSiteId(this.companyId, this.siteId)
    .subscribe((sites) => {

      this.sites$ = of(sites);
      // this.siteName$ = of(sites[0]?.siteName);

      // sites.forEach((site) => {
      //   this.siteName$ = new Observable(observer => {
      //     observer.next(site.siteName);
      //     observer.complete();
      //   });
      // });


    });

    // this.sub1 = this.companySiteToStoreService.getCompanySiteIdUserLocation()
    // .subscribe((state:any) => {

    //   this.companyId = state.companyId;
    //   this.siteId = state.siteId;

    //   // // Maybe we get first site from the last site the user visite.
    //   // if (this.siteId === null) {

    //   //   this.siteId = window.localStorage.getItem('siteId')
    //   // }

    //   this.sitesService.findSiteByCompanyIdSiteId(this.companyId, this.siteId)
    //     .subscribe((sites) => {

    //       this.sites$ = of(sites);
    //       // this.siteName$ = of(sites[0]?.siteName);

    //       // sites.forEach((site) => {
    //       //   this.siteName$ = new Observable(observer => {
    //       //     observer.next(site.siteName);
    //       //     observer.complete();
    //       //   });
    //       // });


    //     });

    // });

  }

  ngOnInit() {
    this.headerTypeOption = this.settings.header;
    this.getCategories();


  }

  public changeTheme(theme: string){
    this.settings.theme = theme;
  }


  public chooseHeaderType(){
    this.settings.header = this.headerTypeOption;
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
    this.router.navigate(['/']);
  }


  @HostListener('window:scroll') onWindowScroll() {
    const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
    (scrollTop > 300) ? this.showBackToTop = true : this.showBackToTop = false;

    if (this.settings.stickyMenuToolbar){
      const top_toolbar = document.getElementById('top-toolbar');
      if (top_toolbar){
        if (scrollTop >= top_toolbar.clientHeight) {
          this.settings.mainToolbarFixed = true;
        }
        else{
          if (!document.documentElement.classList.contains('cdk-global-scrollblock')){
            this.settings.mainToolbarFixed = false;
          }
        }
      }
    }
  }

  public scrollToTop(){
    const scrollDuration = 200;
    const scrollStep = -window.pageYOffset  / (scrollDuration / 20);
    const scrollInterval = setInterval(() => {
      if (window.pageYOffset != 0){
         window.scrollBy(0, scrollStep);
      }
      else{
        clearInterval(scrollInterval);
      }
    }, 10);
    if (window.innerWidth <= 768){
      setTimeout(() => {
        if (isPlatformBrowser(this.platformId)) {
          window.scrollTo(0, 0);
        }
      });
    }
  }

  ngAfterViewInit(){
    if (document.getElementById('preloader')){
      document.getElementById('preloader')?.classList.add('hide');
    }
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.sidenav.close();
        this.settings.mainToolbarFixed = false;
        setTimeout(() => {
          if (isPlatformBrowser(this.platformId)) {
            window.scrollTo(0, 0);
          }
        });
      }
    });
  }

  public getCategories(){
    if (this.appService.Data.categories.length == 0) {
      this.appService.getCategories().subscribe(data => {
        this.appService.Data.categories = data;
      });
    }
  }

}
